import { SaveConfig as DLSaveConfig, GetConfig as DLGetConfig, PrepareScreen as DLPrepareScreen, ExecuteSpin as DLExecuteSpin } from './../DL/Roulette'

/**
 * LÓGICA DE NEGOCIO (BL): ROULETTE
 */

const GetRouletteConfig = async (targetScreenId) => {
    return await DLGetConfig(targetScreenId);
};

// Simplificación: Solo guardamos el texto del premio.
// El Frontend asignará los colores y calculará la probabilidad (1/N) al vuelo.
const SaveRouletteConfig = async (config) => {
    // config.prizes solo necesita traer: [{ text: "Premio 1" }, { text: "Premio 2" }]
    return await DLSaveConfig(config);
};

const PrepareRoulette = async (screenId) => {
    if (!screenId || screenId <= 0) return { success: false, message: 'ID de pantalla inválido.' };
    return await DLPrepareScreen(screenId);
};

const SpinRoulette = async (formData) => {
    const payload = {
        targetScreenId: parseInt(formData.targetScreenId, 10) || 0,
        playerName: formData.playerName || "Aficionado",
        playerContact: formData.playerContact || ""
    };
    return await DLExecuteSpin(payload);
};

export { GetRouletteConfig, SaveRouletteConfig, PrepareRoulette, SpinRoulette };
